import React from 'react';
import {labels} from '../../../util/utils';
import CompareSnapshotLabel from '../../Common/CanvasForm/CompareSnapshotLabel';

const getLabel = (targetHeader) => {
	return <CompareSnapshotLabel snapshotObject={targetHeader} isTrackChanges />;
};

export const getConfig = {
	['TrackChanges']: {
		snapshot: true,
		trackChanges: true,
		queryParameters: {isDrawer: true, isTrackChanges: true},
		frameArgs: {
			drawerChanges: true,
			canOpenNewWindow: false
		},
		name: labels.trackChanges,
		render: getLabel
	},
	['CompareResponses']: {
		snapshot: false,
		compareResponse: true,
		queryParameters: {isDrawer: true, isCompareResponses: true},
		frameArgs: {
			drawerChanges: true,
			canOpenNewWindow: false
		},
		name: labels.compareResponsesLabel
	}
};

export function getConfiguration(source) {
	return source && getConfig[source];
}
